/**
 * extracts custom variant data attributes from a block's computed appearance.
 * standard appearance keys (styles, disabled, loading, etc.) are excluded —
 * only string-valued entries not in the known set become `data-{key}` attributes.
 *
 * this allows theme-managed custom variant dimensions (e.g. radius → data-radius="pill")
 * to flow onto the rendered DOM element so CSS selectors like `[data-radius='pill']` work.
 */
export function getCustomVariantDataAttributes(
  appearance: Record<string, unknown> | undefined,
  knownKeys: Set<string>,
): Record<string, string> {
  if (!appearance) return {};
  const attrs: Record<string, string> = {};
  for (const key of Object.keys(appearance)) {
    if (!knownKeys.has(key) && typeof appearance[key] === 'string') {
      attrs[`data-${key}`] = appearance[key] as string;
    }
  }
  return attrs;
}
